/* Scribble Snacks buy box helpers (Poppy, 29 Sep 2026). Loaded by the "ss_buybox" block in
   templates/product.default-product-features.json. No dependencies beyond the theme's own pubsub.js.
   1. Per-variant delivery estimate (bulky variants get the longer window, never a shorter one).
   2. Mobile sticky add-to-cart bar: shows once the main Add to cart has scrolled off the top; its button
      clicks the main form's own submit button, so the selected variant, quantity and cart drawer all work as normal.
   3. Conversion Bear trust badge headline: the app renders it inside a same-origin iframe (no theme setting),
      so its duplicate "Free Tracked Shipping and Secure Checkout With" is rewritten to "Secure checkout with".
   Rollback: ops/theme-backups/2026-09-29-site-reskin/. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss-buybox]');
  if (!root) return;
  var section = root.getAttribute('data-section');
  var info = document.getElementById('ProductInfo-' + section) || root.closest('.product__info-container');
  var form = document.getElementById('product-form-' + section);
  // The theme swaps parts of the buy box on variant change, so always look the main button up fresh.
  function mainBtn() { return document.getElementById('ProductSubmitButton-' + section); }

  /* ---------- 1. Delivery estimate ---------- */
  var vmap = {}; // variant id -> {b: bulky, t: title, i: image}
  try { vmap = JSON.parse((document.getElementById('ss-bulky-' + section) || {}).textContent || '{}'); } catch (e) {}
  var est = document.querySelectorAll('[data-ss-estimate]'); // the modal moves itself to <body>
  function setEstimate(variantId) {
    if (!variantId) return;
    var v = vmap[String(variantId)];
    var bulky = !!(v && (v === true || v.b === true));
    est.forEach(function (el) {
      el.textContent = el.getAttribute(bulky ? 'data-bulky' : 'data-normal');
      el.classList.toggle('is-bulky', bulky);
    });
  }

  /* ---------- 2. Sticky add to cart (mobile) ---------- */
  var bar = document.getElementById('ss-sticky-' + section);
  var mq = window.matchMedia('(max-width: 749px)');
  function currentVariantId() {
    var f = document.getElementById('product-form-' + section);
    var input = f && f.querySelector('input[name="id"]');
    return input ? input.value : '';
  }
  function priceText() {
    var p = document.getElementById('price-' + section);
    if (!p) return '';
    var sale = p.querySelector('.price--on-sale .price__sale .price-item--last');
    var reg = p.querySelector('.price__regular .price-item--regular');
    return ((sale && sale.textContent) || (reg && reg.textContent) || '').trim();
  }
  function syncBar() {
    if (!bar) return;
    var v = vmap[String(currentVariantId())] || {};
    var priceEl = bar.querySelector('[data-ss-sticky-price]');
    var varEl = bar.querySelector('[data-ss-sticky-variant]');
    var btn = bar.querySelector('button');
    if (priceEl) priceEl.textContent = priceText();
    var img = bar.querySelector('.ss-sticky__img');
    if (img && v.i && img.getAttribute('src') !== v.i) img.setAttribute('src', v.i);
    if (varEl) {
      var t = v.t || varEl.getAttribute('data-initial');
      varEl.textContent = t && t !== 'Default Title' ? t.replace(/ \/ /g, ' · ') : '';
      varEl.hidden = !varEl.textContent;
    }
    var mb = mainBtn();
    if (btn && mb) {
      var off = mb.hasAttribute('disabled') || !currentVariantId();
      btn.disabled = off;
      var label = mb.querySelector('span');
      btn.querySelector('span').textContent = off && label ? label.textContent.trim() : btn.getAttribute('data-label');
    }
  }
  function show(on) {
    if (!bar) return;
    on = on && mq.matches;
    bar.classList.toggle('is-visible', on);
    bar.toggleAttribute('inert', !on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('ss-sticky-on', on);
  }
  if (bar) {
    // Show once the main Add to cart has scrolled off the top (not before the shopper reaches it).
    var ticking = false, lastOn = null;
    function check() {
      ticking = false;
      var mb = mainBtn();
      var r = mb && mb.getBoundingClientRect(); var on = !!mb && (r.bottom < 0 || r.top > window.innerHeight); /* CRO 9 Oct: also while the main button is below the fold */
      if (on !== lastOn) { lastOn = on; if (on) syncBar(); show(on); }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', function () { lastOn = null; check(); });
    bar.querySelector('button').addEventListener('click', function () {
      var mb = mainBtn();
      if (!mb || mb.hasAttribute('disabled')) {
        (info || form).scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      mb.click(); // the theme's product-form handles the add + cart drawer with the selected variant
    });
    check();
  }

  /* variant changes: the theme sets the form's hidden id input (and fires 'change') before it swaps in the new price,
     so sync on the next tick. (This theme build doesn't publish PUB_SUB_EVENTS.variantChange.) */
  function onVariant() { setEstimate(currentVariantId()); syncBar(); }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id' && e.target.form && e.target.form.id === 'product-form-' + section) { setEstimate(e.target.value); setTimeout(syncBar, 0); setTimeout(syncBar, 400); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      if (evt && evt.data && evt.data.sectionId === section) setTimeout(onVariant, 0);
    });
  }
  setEstimate(currentVariantId());
  syncBar();

  /* ---------- 3. Conversion Bear headline ----------
     The app renders with React inside the iframe, so we add a stylesheet to the iframe's <head> (React never touches it)
     rather than editing its nodes. */
  var CB_CSS = '.trustBarTitle{font-size:0!important;line-height:0!important;margin:0 0 4px!important}' +
    '.trustBarTitle::after{content:"Secure checkout with";display:block;font:500 14px/1.4 system-ui,-apple-system,"Segoe UI",sans-serif;color:#5A3A2E;letter-spacing:.02em}' +
    // Ben 29 Sep: smaller payment icons, all on one row on a phone
    '.badgesContainer{display:flex!important;flex-wrap:wrap;justify-content:center;gap:4px}' +
    '.badgeContainer{height:34px!important;width:40px!important}';
  var tries = 0;
  (function fixBadgeTitle() {
    var pending = false;
    document.querySelectorAll('iframe#trust-bar').forEach(function (f) {
      try {
        var d = f.contentDocument;
        if (!d || !d.head || !d.querySelector('.trustBarTitle')) { pending = true; return; }
        if (!d.getElementById('ss-cb-title')) {
          var st = d.createElement('style'); st.id = 'ss-cb-title'; st.textContent = CB_CSS; d.head.appendChild(st);
        }
        // the frame keeps the height of the old, bigger icons: shrink it to fit
        var c = d.querySelector('.trustBarContainer');
        if (c) f.style.height = Math.ceil(c.getBoundingClientRect().height + 4) + 'px';
      } catch (e) { /* cross-origin: leave it */ }
    });
    if ((pending || !document.querySelector('iframe#trust-bar')) && tries++ < 40) setTimeout(fixBadgeTitle, 500);
  })();
})();

/* live 10 Oct 2026 */
